// Module
var code = "<div class=\"inline-help-wizard\"> <div class=\"inline-help-content\"> <div class=\"wizard-title\"> <h2 class=\"mb-20px\">Select the {{whatIsTable}}s</h2> </div> <div class=\"table-selection-container\"> </div> </div> <div class=\"inline-help-helptext open\" style=\"display:none\"></div> </div> ";
// Exports
export default code;